import HeaderMenu from './slick.headermenu';
export default HeaderMenu;
